// extracted by mini-css-extract-plugin
export default {"buyButton_hasPremium":"BuyButton_buyButton_hasPremium__B17oy","check":"BuyButton_check__gWo+I"};